export interface RecordReference {
	id: string;
	reference: string;
}

const RECORD_ID_PATTERN = /\d{3,}/;
const RECORD_GUID_SEGMENT_PATTERN = /^(?:[0-9a-f]{32}|[0-9a-f]{8}(?:-[0-9a-f]{4}){3}-[0-9a-f]{12})$/i;
const RECORD_KIND_SEGMENT_PATTERN = /^[a-z]+(?:-[a-z]+)*$/i;
const LOT_REQUEST_PATTERN = /\blot\s*#?\s*\d+|\blots\b/i;
const LEADING_VERB_PATTERN =
	/^(?:please\s+)?(?:can\s+you\s+)?(?:go\s+to|goto|take\s+me\s+to|navigate\s+to|pull\s+up|bring\s+up|open|show(?:\s+me)?|view|find|see)\s+/i;

const stripRequestVerbs = (requested: string): string => requested.trim().replace(LEADING_VERB_PATTERN, "").trim();

const extractRecordReference = (requested: string | undefined): RecordReference | null => {
	if (!requested) return null;
	const id = requested.match(RECORD_ID_PATTERN)?.[0];
	if (!id) return null;
	const reference = stripRequestVerbs(requested);
	return reference ? { id, reference } : null;
};

const isLotRequest = (requested: string): boolean => LOT_REQUEST_PATTERN.test(requested);

const lotSkipReason = (requested: string): string =>
	`open ${stripRequestVerbs(requested) || "lots"} directly — lots open from the Schedule grid`;

const namesRecordKind = (segment: string | undefined, reference: string): boolean => {
	if (!segment || !RECORD_KIND_SEGMENT_PATTERN.test(segment)) return false;
	const noun = segment.replace(/s$/i, "").replace(/-/g, "\\s+");
	return new RegExp(`\\b${noun}s?\\b`, "i").test(reference);
};

const opensRecordByGuid = (record: RecordReference, path: string): boolean => {
	const segments = path.split(/[?#]/)[0].split("/");
	return segments.some(
		(segment, index) =>
			RECORD_GUID_SEGMENT_PATTERN.test(segment) && namesRecordKind(segments[index - 1], record.reference)
	);
};

const reachedRecord = (record: RecordReference, path: string, reachedDestination?: string): boolean =>
	opensRecordByGuid(record, path) || path.includes(record.id) || !!reachedDestination?.includes(record.id);

export { extractRecordReference, isLotRequest, lotSkipReason, reachedRecord, stripRequestVerbs };
export default extractRecordReference;
